import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import WebSessionStorage from 'redux-persist/lib/storage/session';

import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { APP_NAME } from '@shared/utils/api/configs/URL';

import activitiesEventReducer from '@features/ActivitiesEvents/stores/slice';
import admissionReducer from '@features/Admission/stores/slice';
import appointmentReducer from '@features/Appointment/stores/slice';
import accompanyingVisitorReducer from '@features/ConsentAndPermission/AccompanyingVisitor/store/slice';
import fcReducer from '@features/ConsentAndPermission/FinancialConsents/store/slice';
import nehrAccessRestrictionReducer from '@features/ConsentAndPermission/NehrAccessRestriction/store/slice';
import healthierSGReducer from '@features/HealthierSG/store/slices';
import personalHealthProfileReducer from '@features/HealthProfile/PersonalHealthProfile/store/slice';
import childrenReducer from '@features/HealthRecords/GrowthChart/store/slices';
import mrrpReducer from '@features/HealthRecords/MRRP/store/slice';
import emergencyFormReducer from '@features/HospitalService/store/slice';
import medRefillReducer from '@features/Medication/MedRefill/store/slice';
import autopayReducer from '@features/PaymentsAndFinancial/Autopay/store/slice';
import billsReducer from '@features/PaymentsAndFinancial/Bills/store/slices';
import paymentsReducer from '@features/PaymentsAndFinancial/Payments/store/slices';
import refundsReducer from '@features/PaymentsAndFinancial/Refunds/store/slice';
import paymentServiceReducer from '@features/PaymentService/store/slices';
import pharmacyQueueReducer from '@features/PharmacyQueue/store/slice';

import HealthierSGApptReducer from './healthierSG/healthierSGApptSlice';
import layoutReducer from './layout/layoutSlice';
import newPatientReducer from './newPatient/newPatientSlice';
import originReducer from './origin/originSlice';
import userReducer from './user/userSlice';

const persistConfig = {
  blacklist: ['healthProfile', 'auth', baseApi.reducerPath, 'bridge', 'personalHealthProfile'],
  key: `${APP_NAME}-app-root`,
  storage: WebSessionStorage,
};

const rootReducer = combineReducers({
  accompanyingVisitorReducer,
  activitiesEvent: activitiesEventReducer,
  appointment: appointmentReducer,
  autopay: autopayReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  children: childrenReducer,
  fc: fcReducer,
  healthierSG: healthierSGReducer,
  healthierSgAppt: HealthierSGApptReducer,
  layout: layoutReducer,
  medrefill: medRefillReducer,
  mrrp: mrrpReducer,
  newPatient: newPatientReducer,
  origin: originReducer,
  personalHealthProfile: personalHealthProfileReducer,
  payments: paymentsReducer,
  pharmacyQueue: pharmacyQueueReducer,
  bills: billsReducer,
  refunds: refundsReducer,
  nehrAccessRestriction: nehrAccessRestrictionReducer,
  user: userReducer,
  admission: admissionReducer,
  paymentService: paymentServiceReducer,
  emergencyForm: emergencyFormReducer,
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);
